import { render, staticRenderFns } from "./discounts-goods.vue?vue&type=template&id=545cf1d5&scoped=true"
import script from "./discounts-goods.vue?vue&type=script&lang=js"
export * from "./discounts-goods.vue?vue&type=script&lang=js"
import style0 from "./discounts-goods.vue?vue&type=style&index=0&id=545cf1d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cf1d5",
  null
  
)

export default component.exports